const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GreetingNotesQuery: any = {
    ListOfGreetingNotes: Backofficebff + '/v1/greetingnotes/list-all-greeting-notes',
};
